<template>
  <div class="page_content wheel_spin fixed_page">

    <div class="main_section">
      <div class="container">

        <div class="row justify-content-center top_title">
          <div class="col-12">
            <div
              class="inside_alignment_spin d-flex flex-column flex-md-row flex-lg-row justify-content-center align-items-center my-0 my-lg-5 my-md-5">
              <div
                class="d-flex flex-column text-center align-items-left mr-0 ml-lg-5 ml-md-5 ml-0">
                <div class="text-md-left">
                  <h1>Gefeliciteerd!</h1>
                </div>
                <h2 class="w-100 w-lg-50 w-md-50 text-center text-lg-left text-md-left">
                  Draai het rad voor je prijzen! <br>Wat ga je winnen? <br>Succes!
                </h2>
                <h2
                  class="w-100 w-lg-50 w-md-50 text-center text-lg-left text-md-left font-weight-bold mt-4"
                  v-if="telcoWin">
                  Je hebt een Odido Surprise gewonnen.<br> Draai nog een keer.
                </h2>
                <h3 class="w-100 w-lg-50 w-md-50 text-center text-lg-left text-md-left">
                  Je hebt nog {{ this.availableSpins }} kans(en)</h3>
                <button type="button" @click="play()" :disabled=disabled
                        class="black_btn start_button desktop">
                  Start
                </button>
              </div>

              <div id="wrapper">
                <img src="../assets/img/millen_images/wheel_bg.png"
                     class="wrapper" alt="">
                <div class="spin_content">
                  <button type="button" @click="play()" :disabled=disabled
                          class="spin_the_wheel"></button>
                </div>
                <div id="wheel" :class="colorSpin">
                  <div id="inner-wheel">
                    <div class="sec">
                      <span class="fa" v-html="triangle1"></span>
                    </div>
                    <div class="sec">
                      <span class="fa" v-html="triangle2"></span>
                    </div>
                    <div class="sec">
                      <span class="fa" v-html="triangle3"></span>
                    </div>
                    <div class="sec">
                      <span class="fa" v-html="triangle4"></span>
                    </div>
                    <div class="sec">
                      <span class="fa" v-html="triangle5"></span>
                    </div>
                    <div class="sec">
                      <span class="fa" v-html="triangle6"></span>
                    </div>
                  </div>
                </div>
              </div>

              <button type="button" @click="play()" :disabled=disabled
                      class="black_btn start_button mobile">
                Start
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import {resetWheelPosition, spinTheWheel} from '../common/jQuery'
import router from '../router'
import gameFlow from '../common/mixin/gameFlow'

export default {
  name: 'SpinWheel',
  mixins: [
    gameFlow
  ],
  data() {
    return {
      initialSpins: 0,
      numOfClicks: 0,
      degree: 1800,
      haveRewardResponse: false,
      normalDurationPassed: false,
      showResult: false,
      isMounted: false,
      telcoWin: false,
      disabled: false,
      topUp10: 10,
      topUp15: 15,
      topUp20: 20,
      isBronze: false,
      isGold: false,
      isPlatinum: false,
      noPhysical: '',
      withPhysical: '<img src="static/img/millen_images/gift_black.svg" alt="">',
      triangle1: '',
      triangle2: '',
      triangle3: '',
      triangle4: '',
      triangle5: '',
      triangle6: '',
      result: '',
      colorSpin: '',
    }
  },
  computed: {
    ...mapGetters([
      'getTopUpValue',
      'hasFoundBonusImage',
      'getAvailableSpins',
      'getHasBeenAwarded',
      'getExtraChance',
      'getGameResponse',
      'getIsPromoBundleCR207',
      'getIsPromoBundleCR208',
      'getIsPromoBundleCR209',
      'getIsPromoBundleIR405',
      'getPlaysCount',
      'getPlayChances',
    ]),
    availableSpins() {
      return (this.getAvailableSpins > 0) ? this.getAvailableSpins : 0
    }
  },
  created() {
    if ((Number(this.getPlayChances) !== 0)) {
      this.calculateCategory()
    } else {
      setTimeout(() => {
        this.calculateCategory()
    }, 700)
    }
  },
  mounted() {
    if (this.getExtraChance) {
      this.updateAvailableSpins(1)
    }
    this.setInGameFlow("true", this.$route.path.substring(1))
  },
  methods: {
    ...mapMutations([
      'updateHasBeenAwarded',
      'updateGameResponse',
      'updateAvailableSpins',
      'updateTelcoValidRewardIds',
      'updatePlaysCount',
    ]),
    ...mapActions([
      'playGame'
    ]),
    initSpinCounter() {
      setTimeout(() => {
        this.updateAvailableSpins(this.getAvailableSpins - 1)
      }, 4000) // do action after 4 seconds passed (minimum spin wheel duration)
    },
    calculateResult() {
      if (this.isBronze) {
        this.result = this.getHasBeenAwarded ? 0 : 5
      } else if (this.isGold) {
        if (this.getHasBeenAwarded) {
          if (this.getRewardId() == 0 || this.getRewardId() == 2) {
            this.result = 0
          } else {
            this.result = 3
          }
        } else {
          this.result = 5
        }
      } else if (this.isPlatinum) {
        this.result = this.getHasBeenAwarded ? this.getRewardId() : 5
      }

      return this.result // 5: try again state
    },
    getRewardId() {
      return parseInt(this.getGameResponse.spinSlice[1])
    },
    spin() {
      let result = this.calculateResult()
      setTimeout(() => {
        spinTheWheel(this.numOfClicks, this.degree, result)
      }, 5)
      this.spinFlow()
    },
    play() {
      if (this.disabled) {
        return
      }
      this.calculateCategory()
      this.disabled = true
      this.telcoWin = false
      resetWheelPosition()
      this.initSpinCounter()
      this.playGame()
        .then(response => {
          this.$store.commit('updateGameResponse', response.data.params)
          this.$store.commit('updateHasBeenAwarded', response.data.params.hasBeenAwarded)
          this.$store.commit('updateAvailableSpins', this.getGameResponse.playChances[1] - this.getGameResponse.playsCount[1] + 1)
          if (response.data.params.physicalExtraChance === undefined || !response.data.params.physicalExtraChance)
            this.$store.commit('updateExtraChance', false)
            if (response.data.params.playsCount !== null && response.data.params.playsCount !== undefined) {
              this.$store.commit('updatePlaysCount', response.data.params.playsCount[1])
            }
          this.spin()
          if (response.data.params.validRewardIds != null) {
            this.$store.commit('updateTelcoValidRewardIds', this.createRewardIdParam(response.data.params.validRewardIds[1]))
          }
        })
    },
    spinFlow() {
      setTimeout(() => {
          if (this.getHasBeenAwarded) {
            router.push({name: 'PhysicalPrize'})
          } else if (this.getExtraChance) {
            router.push({name: 'SocialShare'})
          } else if (this.getAvailableSpins <= 0) {
            router.push({name: 'TelcoPrize'})
          }
          if (!this.getHasBeenAwarded) {
            this.disabled = false
            this.telcoWin = true
          }
        }, 6500
      )
    },
    calculateCategory() {
      //set the correct label based on how many play chances the customer has and how many times he has already played
      if ((Number(this.getPlayChances) === 2 && Number(this.getPlaysCount) === 0) ||
          (Number(this.getPlayChances) === 1 && Number(this.getPlaysCount) === 0)) {
        this.noPhysical = '<p>Odido Surprise</p>'
      }
      else {
        this.noPhysical = '<p>Volgende keer beter</p>'
      }

      //display the correct spin according to topup value or bundle
      if (this.getTopUpValue >= this.topUp20 || this.getIsPromoBundleCR207 || this.getIsPromoBundleCR208 || this.getIsPromoBundleCR209 || this.getIsPromoBundleIR405)
        this.isPlatinum = true;
      else if (this.getTopUpValue >= this.topUp15 && this.getTopUpValue < this.topUp20)
        this.isGold = true;
      else if (this.getTopUpValue < this.topUp15)
        this.isBronze = true;

      if (this.isBronze) {
        this.colorSpin = 'orange'
        this.triangle1 = this.noPhysical
        this.triangle2 = this.withPhysical
        this.triangle3 = this.noPhysical
        this.triangle4 = this.noPhysical
        this.triangle5 = this.noPhysical
        this.triangle6 = this.noPhysical
      }
      if (this.isGold) {
        this.colorSpin = 'purple'
        this.triangle1 = this.noPhysical
        this.triangle2 = this.withPhysical
        this.triangle3 = this.noPhysical
        this.triangle4 = this.noPhysical
        this.triangle5 = this.withPhysical
        this.triangle6 = this.noPhysical
      }
      if (this.isPlatinum) {
        this.colorSpin = 'multi_color'
        this.triangle1 = this.noPhysical
        this.triangle2 = this.withPhysical
        this.triangle3 = this.noPhysical
        this.triangle4 = this.withPhysical
        this.triangle5 = this.noPhysical
        this.triangle6 = this.withPhysical
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SpinWheel.vue